(function (angular) {
    'use strict';

    angular.module('profiles')

        /**
         *
         */
        .directive('profileField', [function () {

            var controllerFn = ['$scope', 'uploadFileService', '$timeout', 'moment',
                function ($scope, uploadFileService, $timeout, moment) {
                    
                    var timer, splitHours;
                    $scope.expired = "Expired";

                    $scope.boolOptions = [{
                        val: true,
                        label: 'true'
                    },{
                        val: false,
                        label: 'false'
                    }];
                    
                    if (!$scope.letters) {
                        $scope.letters = 18;
                    }
                    $scope.calendar = {
                        opened: false
                    }
                    $scope.open = function ($event, calendar) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        calendar.opened = true;
                    };

                    function countdown(){

                        var counterValue = moment($scope.property.value);
                        for(var index in splitHours){
                            counterValue.add(splitHours[index].slice(0,2), splitHours[index].slice(2,3));
                        }

                        var diff = counterValue.diff(moment());
                        var duration = moment.duration(diff);
                        var result = "";
                        if(diff > 3600000){
                            result += duration.hours() + "h "
                        }
                        if(diff > 60000){
                            result += duration.minutes() + "min "
                        }
                        if(diff > 0){
                            result += duration.seconds() + "sec"
                        }

                        if(diff <= 0){
                            $scope.value = $scope.expired;
                            $scope.isExpired = true;
                        } else {
                            $scope.value = result;
                            
                            timer = $timeout(function(){
                                return countdown();
                            }, 1000);
                        }
                    }

                    $scope.start = function () {

                        var property = $scope.property;

                        if (property.type === "interaction" && $scope.interactions && $scope.interactions.length){
                            $scope.interactionDetails = $scope.interactions.find((i) => i.id === property.id);
                            $scope.interactionDisplay = () => {
                                if(typeof $scope.interactionDetails.shouldDisplay === "function"){
                                    return $scope.interactionDetails.shouldDisplay();
                                } else {
                                    return $scope.interactionDetails.shouldDisplay;
                                }
                            }
                            $scope.interactiveController = $scope.interactionDetails.controller;
                        }

                        if (property.type === 'image' && property.default) {
                            $scope.defaultImage = property.default;
                        }

                        if(property.type === "counter" && property.value){
                            splitHours = $scope.property.countTo.split(":");
                            countdown();
                        }

                        if (property.value !== undefined && property.value !== null) {
                            if (property.type === 'date') {
                                property.value = new Date(property.value);
                            }
                            else {
                                property.value = property.value;
                            }
                        }
                        else if (property.type == 'image') {
                            property.value = property.default;
                        }
                        else {
                            property.value = '';
                        }

                        if(property.type !== "counter"){
                            $scope.value = property.value;
                        }

                        if(property.type === "displayableObject" && property.value && typeof property.value === "object"){
                            $scope.propertiesCount = 0;
                            var objectToDisplay = ""
                            for(var propertyName in property.value){
                                $scope.propertiesCount++;
                                var propertyVal = property.value[propertyName];
                                objectToDisplay += "<div><strong>" + propertyName + ": </strong>";
                                if(propertyVal){
                                    objectToDisplay += "<span class='break-word'>" + propertyVal + "</span>";
                                }
                                objectToDisplay += "</div>"
                            }
                            $scope.objectToDisplay = objectToDisplay;
                        }

                        $scope.type = property.type;
                        $scope.locked = property.locked;
                        $scope.model = property;
                        $scope.lastValue = property.value;
                        $scope.label = property.label;
                    };

                    if($scope.property.type === "counter"){
                        $scope.$watch('property.value', (newValue, oldValue) => {
                            if(newValue && $scope.isExpired && newValue !== oldValue){
                                delete $scope.isExpired;
                                countdown();
                            }
                        });
                    }

                    $scope.start();
                    $scope.$on('profile:cancel', function (event, data) {
                        $scope.model.value = $scope.lastValue;
                        $scope.value = $scope.lastValue;
                    });
                    $scope.$on('profile:save', function (event, data) {
                        $scope.start();
                    });

                    $scope.uploadImage = function () {
                        uploadFileService.uploadFile().then(function (result) {
                            $scope.property.value = result.url;
                            $scope.value = result.url;
                        });
                    };

                    $scope.$on('$destroy', function() {
                        $timeout.cancel(timer);
                    });
                }

            ];
            return {
                restrict: 'EA',
                scope: {
                    edit: "=",
                    hideTooltip: "=",
                    property: "=",
                    letters: "=?",
                    placeholder: "=?",
                    interactions: "=?"
                },
                templateUrl: 'components/toolkit/profiles/templates/directive.profileField.html',
                controller: controllerFn
            };
        }])
        .directive('clickAway', ['$document', function ($document) {
            return {
                link: function postLink(scope, element, attrs) {
                    var onClick = function (event) {
                        var isChild = element[0].contains(event.target);;
                        var isSelf = element[0] == event.target;
                        var isInside = isChild || isSelf;
                        if (!isInside) {
                            scope.$apply(attrs.clickAway)
                        }
                    }

                    scope.$watch(attrs.isActive, function (newValue, oldValue) {
                        if (newValue !== oldValue && newValue == true) {
                            $document.bind('click', onClick);
                        }
                        else if (newValue !== oldValue && newValue == false) {
                            $document.unbind('click', onClick);
                        }
                    });
                }
            };
        }]);
})(window.angular);

